module.exports = __webpack_public_path__ + "static/media/Comfortaa-Light.78fedec1.svg";